import { render, staticRenderFns } from "./colorpicker.vue?vue&type=template&id=97f74b44&scoped=true"
import script from "./colorpicker.vue?vue&type=script&lang=js"
export * from "./colorpicker.vue?vue&type=script&lang=js"
import style0 from "./colorpicker.vue?vue&type=style&index=0&id=97f74b44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f74b44",
  null
  
)

export default component.exports